<template>
  <div>
    <br>

    <div class="backContainer">
      <transition name="back" mode="out-in">
        <!-- <ul > -->
        <div v-if="toAnimate" class="backDiv" @click="goBack()">
          <!-- <div class="backDivBG"></div> -->
          <button class="backButton">BACK?</button>
          <!-- <div class="scroll"></div> -->
        </div>
        <!-- </ul> -->
      </transition>
    </div>
   
<div class="imageContainer">
  <transition name="images" mode="out-in">
    <div v-if="toAnimate">
      <div v-if="showSlider">
      <!-- <p>GALLERY</p> -->
      <carousel  :center=false :nav=false :item=3 :margin=10 :dots=true :dotsEach=true>
      <div v-for="(image,index) in images" :key="index" ><img :src=images[index] v-on:click="GalleryIndex = index"></div>
      </carousel>
      <div>
        <gallery :images="images" :index="GalleryIndex" @close="GalleryIndex = null"></gallery>
      </div>
      </div>
      <div v-else> <p>sorry but i got no images :(</p></div>
    </div>
  </transition>
</div>


<div class="contentContainer">
<transition name="contents" mode="out-in">
    <div v-if="toAnimate">

    <div class="contentYear">{{ info.Year }}
      <span v-if="info.Month!='-'">
      | {{ info.Month }}
      </span>
    </div>

    <div v-if="info.Info!=undefined">
      <div v-for="line in info.Info.split('\n\n')" :key="line" class="contentInfo">
        <p  v-for="sentence in line.split('\n')" :key="sentence"  class="contentSent"> {{sentence}}</p>
      </div>
    </div>
    
    <hr class="myLine">
    </div>
  </transition>
</div>
    </div>
</template>

<script>
import axios from "axios";
import {store} from "../store.js";
import carousel from 'vue-owl-carousel';
import VueGallery from 'vue-gallery';

export default {
   components: { carousel,
   'gallery': VueGallery },
  data() {
    return {
      info: null,
      path: this.$router.currentRoute.path.split("/")[1],
      infoName: null,
      images: null,
      index:0,
      active:0,
      showSlider:false,
      GalleryIndex:null,
      toAnimate:null
    };
  },
  methods: {
    allInfo: function() {
      axios
        .get(store.getphpPath() + "DBtry.php", {
          params: {
            type: "selected",
            table: this.$router.currentRoute.path.split("/")[1],
            rowID: this.$router.currentRoute.path.split("/")[2]
          },
          // responseType:'json'
        })
        .then(response => {
          // console.log("Testing \n" + response.data);
          if (response.data.length == 0){
            // console.log("EMPTY");
            this.$router.push('/404');
          }
          else{
          // console.log(response.data);
          // console.log(response.data[0]);
          // console.log(this.info);
          this.info = response.data[0];
          this.$nextTick(function () {this.toAnimate=true; })
          if(store.getSubPath()==""){
            store.setSubPath(response.data[0].Name.toUpperCase())
          }
          this.getImages();
        }
        })
        .catch(error => {
          // console.log("OOOOPS");
          console.log(error);
        });
    },
    getImages: function() {
      axios
        .get(store.getphpPath() + "getImagesDBtry.php", {
          params: {
            table: this.$router.currentRoute.path.split("/")[1],
            rowID: this.$router.currentRoute.path.split("/")[2]
          }
        })
        .then(response => {
          this.images = response.data[0];
          if(response.data[0].length>0){
            this.showSlider = true;
          }
          // console.log(response.data[0]);
        })
        .catch(error => {
          // console.log("OOOOPS");
          console.log(error);
        });
    },
    // getPath: function(Imagepath) {
    //   return require("../assets/" + Imagepath);
    // },
    goBack() {
      this.$router.push("/" + this.$router.currentRoute.path.split("/")[1]);
    },
    // getSubPath(infoName){
    //   sharedState.setSubPath(infoName)
    // }
  },
  created() {
    this.allInfo();
  },
  // watch: {
  //   $route(to, from) {
  //     console.log("WATCHING")
  //     this.allInfo();
  //   }
  // }  ,
  beforeRouteLeave(to, from, next){
    // console.log(this.info);
    this.toAnimate=false;

    if(to.name=="me"){      
      setTimeout(() => { 
        store.clearSubPath();
        setTimeout(() => { next() }, 500) }, 1000)
    }
    else{
        setTimeout(() => { next() }, 1000)
    }
  }

};
</script>

<style>

.owl-theme .owl-dots .owl-dot span{
    background: transparent !important;
    display:block;
    border: 1px solid white;
}

.owl-theme .owl-dots .active span{
    background: white !important;
}

.owl-carousel .owl-stage {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.anim5-enter-active,.anim5-leave-active {
  -webkit-transition: all 0.8s ease;
  -o-transition: all 0.8s ease;
  transition: all 0.8s ease;
}
.anim5-leave-to{
  -webkit-transform: translateY(5em);
      -ms-transform: translateY(5em);
          transform: translateY(5em);
}

.anim5-enter{
  -webkit-transform: translateY(-5em);
      -ms-transform: translateY(-5em);
          transform: translateY(-5em);
}

.backButton{
  font-family: "Courier";
  font-weight: 500;
  z-index: 1;
  /* background-color: white; */
  color: black;
  margin:0 auto;
  vertical-align: middle;
  padding:0.17em;
   opacity: 1;
   -webkit-transition : 0.4s ease;
   -o-transition : 0.4s ease;
   transition : 0.4s ease;
}

.backDiv{
  text-align:center;
  background-color: rgb(165, 165, 165);
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  overflow: hidden;
  /* -webkit-transition : 0.4s ease;
  -o-transition : 0.4s ease;
  transition : 0.4s ease; */

  /* width: 100%; */
  /* height: 20px; */
  /* opacity: 0.7; */
  /* backdrop-filter: url(#kill); */
  -webkit-filter: url(#kill);
          filter: url(#kill);
  /* animation:chromatic 5.2s infinite ease; */
  /* animation: letter-flicker 10s linear infinite; */
}


.backDiv:hover{
  opacity: 1;
  background-color:white;
  /* font-weight: 900; */
  -webkit-filter: none;
          filter: none;
}

/* .backDivBG{
  position: relative;
} */

/* .backDivBG{
  background-color:white;
  background-size: cover;
  display: block;
  width: 100%;
  height: 100%;
  filter: url(#kill);
  left: 0;
  right: 0;
  z-index: -1;
} */

/* .scroll {
    position: fixed;
    left: 0px;
    height: 20px;
    width: 100%;
    z-index: 1;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='20px' width='50px'><text x='0' y='15' fill='black' font-size='17'> - </text></svg>");
  } */



.backContainer{
  overflow: hidden;
}

.back-enter-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.back-leave-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.7s;
       -o-transition-delay: 0.7s;
          transition-delay: 0.7s;
}
.back-enter {
  /* opacity: 0; */
  -webkit-transform: translateX(700px);
      -ms-transform: translateX(700px);
          transform: translateX(700px);
}
.back-leave-to {
  /* opacity: 0; */
  -webkit-transform: translateX(-900px);
      -ms-transform: translateX(-900px);
          transform: translateX(-900px);
}

/* Images */

.imageContainer{
  text-align: center;
  overflow: hidden;
  margin-top: 1em;;
}

.imageContainer p{
      font-family: 'Courier New', Courier, monospace;
      font-size:15px;
      color: lightcoral;
}

.images-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.3s;
       -o-transition-delay: 0.3s;
          transition-delay: 0.3s;
}
.images-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.3s;
       -o-transition-delay: 0.3s;
          transition-delay: 0.3s;
}
.images-enter {
  opacity: 0;
  -webkit-transform: translateY(-500px) !important;
      -ms-transform: translateY(-500px) !important;
          transform: translateY(-500px) !important;
}
.images-leave-to {
  opacity: 0;
  -webkit-transform: translateY(-500px);
      -ms-transform: translateY(-500px);
          transform: translateY(-500px);
}

/* Content */

.contentContainer{
  /* text-align: center; */
  overflow: hidden;
  margin-top: 1em;;
}

.contentYear{
  font-family: 'Courier New', Courier, monospace;
  text-align: center;
}

.contentInfo{
  font-size: 1em;
  font-family: 'Courier New', Courier, monospace;
  letter-spacing: 0.0000001px;
  margin: 16px 0px;
}

.contentSent{
  margin: 0;
}

.myLine{
  border-top: 1px solid white;
  border-width: 0.5px;
}
.contents-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.7s;
       -o-transition-delay: 0.7s;
          transition-delay: 0.7s;
}

.contents-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.contents-enter {
  opacity: 0;
  -webkit-transform: translateY(-500px) !important;
      -ms-transform: translateY(-500px) !important;
          transform: translateY(-500px) !important;
}

.contents-leave-to {
  opacity: 0;
  -webkit-transform: translateY(-500px);
      -ms-transform: translateY(-500px);
          transform: translateY(-500px);
}


@-webkit-keyframes scrollGood {
  0% {
    -webkit-transform: translate3d(0,0,0);
            transform: translate3d(0,0,0);
  }
  100% {
    -webkit-transform: translate3d(-300px,0,0);
            transform: translate3d(-300px,0,0);
  }
}


@keyframes scrollGood {
  0% {
    -webkit-transform: translate3d(0,0,0);
            transform: translate3d(0,0,0);
  }
  100% {
    -webkit-transform: translate3d(-300px,0,0);
            transform: translate3d(-300px,0,0);
  }
}
</style>
